import { useState, useRef, useEffect } from "react";
import { highlightItem as highlightItemUtil } from "../preOrders/preOrderUtils";

/**
 * Hook to manage item highlight animations.
 * Replaces the duplicated highlight pattern in menu.tsx and basket.tsx.
 *
 * Clears all pending highlight timeouts on unmount to prevent state
 * updates after the component (or test environment) has been torn down.
 *
 * @returns {{ highlightedItems: Set<string>, highlight: (itemKey: string) => void }}
 */
export function useItemHighlight() {
  const [highlightedItems, setHighlightedItems] = useState<Set<string>>(new Set());
  const highlightTimeoutsRef = useRef<Map<string, ReturnType<typeof setTimeout>>>(new Map());

  const highlight = (itemKey: string) => {
    highlightItemUtil(itemKey, setHighlightedItems, highlightTimeoutsRef);
  };

  // Clear all pending highlight timeouts on unmount
  useEffect(() => {
    return () => {
      for (const timeout of highlightTimeoutsRef.current.values()) {
        clearTimeout(timeout);
      }
      highlightTimeoutsRef.current.clear();
    };
  }, []);

  return { highlightedItems, highlight };
}
